import React from "react";
import { withStyles } from "@material-ui/core";
import { get, filter, size } from "lodash";

import Grid from "@material-ui/core/Grid";
// import Menu from '@material-ui/core/Menu';
// import MenuItem from '@material-ui/core/MenuItem';
// import { I18n } from "aws-amplify";

import SchedulerOccurrenceView from "../SchedulerOccurrenceView/SchedulerOccurrenceView";

import { darkenColor } from "../../../utils/color";
import { getAttributeValue } from "../../../utils/profile";
import { getOccurrenceArrival } from "../../../utils/scheduler";

import images from "../../../assets/img/images";
import colors from "../../../assets/style/colors";

const styles = {
  container: {
    padding: "3px",
    marginBottom: "2px",
    cursor: "pointer",
  },
  dataLine: {
    marginBottom: "4px",
  },
  iconItem: {
    width: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "12px",
    "& img": {
      height: "12px",
    },
  },
  dataItem: {
    color: colors.black87,
    fontSize: "0.857em",
    height: "12px",
    lineHeight: "12px",
  }
};

const SchedulerOccurrenceWeekly = (props) => {
  const { classes, group, timeSlots, refresh } = props;
  const [open, setOpen] = React.useState(false);
  const [edit, setEdit] = React.useState(false);
  const [del,  setDel] = React.useState(false);

  const occurrenceStart = getOccurrenceArrival(group);

  const hostProfile = get(
    filter(
      get(occurrenceStart, ["profiles"]),
      (p) => get(p, ["association_type", "id"]) === 1
    ),
    [0, "profile"]
  );

  const zoneColor =
    get(occurrenceStart, ["zones", 0, "zone", "color", "rgb"]) ||
    get(occurrenceStart, ["zones", 0, "zone", "type", "color", "rgb"]);

  function MouseOver(event) {
    var id = event.target.id;
    
    // var allContainers = document.getElementsByClassName("MuiGrid-root SchedulerOccurrenceWeekly-container-625 MuiGrid-item")
    // var allContainers_round = document.getElementsByClassName("MuiGrid-root SchedulerOccurrenceWeekly-iconItem-627 MuiGrid-item")

    var allContainers = document.querySelectorAll('[name^="muigridcontainer"]')
    var allContainers_round = document.querySelectorAll('[name^="roundicon"]')

    for (var i=0;i<size(allContainers);i++){
      if (allContainers[i]["id"] === id){
        allContainers[i].style.outline = "0.5px solid #5f00a0"
        allContainers[i].style.outlineOffset = "-0.5px"
        allContainers[i].style.borderLeft = `3px solid ${darkenColor(zoneColor)}`
      }
    }

    for (i=0;i<size(allContainers_round);i++){
      if (allContainers_round[i]["id"] === id+"round"){
        allContainers_round[i].style.visibility = "visible"
        allContainers_round[i].style.zIndex = "1000"
      }
    }
  }
  function MouseOut(event){
    var id = event.target.id;
    var allContainers = document.querySelectorAll('[name^="muigridcontainer"]')
    var allContainers_round = document.querySelectorAll('[name^="roundicon"]')
    for (var i=0;i<size(allContainers);i++){
      if (allContainers[i]["id"] === id){
        allContainers[i].style.outline = "none"
        allContainers[i].style.outlineOffset = "-0.5px"
        allContainers[i].style.borderLeft = `3px solid ${darkenColor(zoneColor)}`
      }
    }

    for (i=0;i<size(allContainers_round);i++){
      if (allContainers_round[i]["id"] === id+"round"){
        allContainers_round[i].style.visibility = "hidden"
      }
    }
  }  

  // const [anchorEl, setAnchorEl] = React.useState(null);

  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  return (
    <Grid
      item
      data-test="scheduler-occurrence-component"
      className={classes.container}
      name="muigridcontainer"
      // onClick={() => {setEdit(false); setOpen(true)}}
      onMouseOver={MouseOver}
      onMouseOut={MouseOut}
      onDoubleClick={(e) => e.stopPropagation()}
      id={occurrenceStart["id"]}
      style={{
        border: zoneColor ? "none" : `1px solid ${colors.black}`,
        borderLeft: `3px solid ${darkenColor(zoneColor)}`,
        backgroundColor: zoneColor ? `#${zoneColor}` : colors.white,
        height: !zoneColor ? "42px" : "",
        ...props.style,
      }}
    >
      
      {open && (
        <SchedulerOccurrenceView
          open={open}
          setOpen={setOpen}
          occurrence={group}
          timeSlots={timeSlots}
          refresh={refresh}
          edit={edit}
          del={del}
        />
      )}
      <Grid container direction="column" id={occurrenceStart["id"]} onClick={() => {setEdit(false); setOpen(true)}}>
        <Grid
          item
          container
          alignItems="center"
          className={classes.dataLine}
          data-test="scheduler-occurrence-name"
          id={occurrenceStart["id"]}
        >
          <Grid item className={classes.iconItem} id={occurrenceStart["id"]}>
            <img src={images.humanIconBlack} alt="human_icon" id={occurrenceStart["id"]}/>
          </Grid>
          <Grid item className={classes.dataItem} id={occurrenceStart["id"]}>
            {`${get(hostProfile, ["firstname"])} ${get(hostProfile, [
              "lastname",
            ])}`}
          </Grid>
        </Grid>
        <Grid
          item
          container
          alignItems="center"
          className={classes.dataLine}
          data-test="scheduler-occurrence-unit"
          id={occurrenceStart["id"]}
        >
          <Grid item className={classes.iconItem} id={occurrenceStart["id"]}>
            <img src={images.locationIcon} alt="location" id={occurrenceStart["id"]}/>
          </Grid>
          <Grid item className={classes.dataItem} id={occurrenceStart["id"]}>
            {get(occurrenceStart, ["zones", 0, "zone", "name"])}
          </Grid>
        </Grid>
        <Grid
          item
          container
          alignItems="center"
          data-test="scheduler-occurrence-visitors"
          id={occurrenceStart["id"]}
        >
          <Grid item className={classes.iconItem} id={occurrenceStart["id"]}>
            <img src={images.pedestrianIcon} alt="pedestrian" id={occurrenceStart["id"]} />
          </Grid>
          <Grid item xs className={classes.dataItem} id={occurrenceStart["id"]}>
            {size(
              filter(
                get(occurrenceStart, ["profiles"]),
                (p) => get(p, ["association_type", "id"]) === 2
              )
            )}
          </Grid>
          {getAttributeValue(occurrenceStart, 19) && (
            <Grid item className={classes.dataItem} id={occurrenceStart["id"]}>
              <img src={images.commentIconBlack} alt="comments" />
            </Grid>
          )}
        </Grid>
      </Grid>
      
      <Grid id={occurrenceStart["id"]}>
        <Grid
          item
          id={occurrenceStart["id"]}
        >
          <Grid item name="roundicon" className={classes.iconItem} id={occurrenceStart["id"]+"round"} style={{position: "relative",left:"160px",top:"-42px", visibility:"hidden", height:"0px"}}>
            <img src={images.round} id={occurrenceStart["id"]} alt="round_icon" onClick={() => { setEdit(true); setDel(false); setOpen(true)}} style={{width:"25px", height:"25px"}}/>
          </Grid>
          {/* <Grid item id={occurrenceStart["id"]+"menu"} style={{position: "relative",top:"-7.5px", visibility:"visible"}}>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={() => { handleClose(); setEdit(true); setDel(false); setOpen(true)}}>{I18n.get("edit")}</MenuItem>
              <MenuItem style={{color:"red"}} onClick={()=>{handleClose(); setEdit(true); setDel(true); setOpen(true)}}>{I18n.get("delete")}</MenuItem>
            </Menu>
          </Grid> */}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(SchedulerOccurrenceWeekly);
